/**
 * Redux witness watchers for location
 * @module services/location/watchers
 */
import { SET_LOCATION, setLocationData as setLocationDataAction } from './redux/actions'
import { parseWindowLocationHref } from '.'

/**
 * Set location watcher that will set location data
 * @param {Object} param0 The parameters
 * @param {Function} param0.takeEvery The witness take every function
 */
export function setLocation ({ takeEvery } = {}) {
  return takeEvery(SET_LOCATION, ({ action }) => {
    const { payload: { location } = {} } = action
    const data = parseWindowLocationHref(location)
    return setLocationDataAction({ data })
  })
}
